import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyle = createStyles((them: MantineTheme) => ({
  loadingScreen: {
    backgroundColor: "rgba(243, 236, 218, .5)",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loadingIcon: {
    width: "269px",
    height: "184px",
  },
  container: {
    backgroundColor: "#ffffffff",
    padding: "40px 40px 5px 6px",
    border: "2px solid #c9c9c9ff",
    borderRadius: "0.45rem",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "70px",
    marginTop: "150px",
    width: "90%",
  },
  headerText: {
    width: 361,
    height: 46,
    top: 95,
    left: 150,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: "0em",
    textAlign: "left",
    fontStyle: "normal",
  },
  text: {
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: 400,
    marginBottom: "30px",
  },
  subHeading: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "30px",
  },
  proceedButton: {
    backgroundColor: "#338F86",
    "&:hover": {
      backgroundColor: "#197a70",
    },
    padding: "10px",
    borderRadius: "0.45rem",
    border: "1px solid #ffffffff",
    color: "white",
    width: "90%",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    minHeight: "180vh", // keeps things vertically centered
  },
}));
